import { FC } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { selectRunOutModalStatus, toogleRunOutModal } from '../../store/slices/modalSlice';
import CustomButton from '../../common/CustomButton';

import RunOutImg from '../../assets/images/runOut.png';

import styles from './RunOutSubscriptionModal.module.scss';

const RunOutSubscriptionModal: FC = () => {
  const dispatch = useAppDispatch();
  const { runOutModal } = useAppSelector(selectRunOutModalStatus);

  const handleClose = () => {
    dispatch(toogleRunOutModal());
  };

  return (
    <Modal
      open={runOutModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 'fit-content',
          minWidth: 343,
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: '20px',
          p: '32px 90px',
          overflowY: 'auto',
          boxShadow: 'none',
          maxHeight: '90vh',
          '@media (max-width: 900px)': {
            p: '32px 15px',
          },
        }}
      >
        <Box sx={{ position: 'absolute', top: 16, right: 20, cursor: 'pointer' }}>
          <CloseIcon
            sx={{ width: '30px', height: '30px' }}
            onClick={handleClose}
          />
        </Box>
        <Box className={styles.modalContentWrapper}>
          <img
            src={RunOutImg}
            className={styles.modalImg}
            alt="info iamge"
            draggable="false"
          />
          <Typography
            variant="h5Bold"
            className={styles.title}
          >
            Stay connected to all your smart features
          </Typography>
          <Box className={styles.modalContent}>
            <Typography
              variant="h10"
              className={styles.content}
            >
              You have 30 days left of full access. Renew now to keep unlimited document storage, advanced tools, and
              full control over your data — without interruptions.
            </Typography>
          </Box>
          <CustomButton customClass={styles.customBtn}>Renew Now</CustomButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default RunOutSubscriptionModal;
